module.exports = __webpack_public_path__ + "static/media/goldPlus.1e1df2fc.svg";